import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { RefreshCw, Search } from 'lucide-react';

interface VPESearchFormProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  onSearch: () => void;
  onReload: () => void;
  isLoading: boolean;
}

const VPESearchForm: React.FC<VPESearchFormProps> = ({
  searchTerm,
  onSearchTermChange,
  onSearch,
  onReload,
  isLoading
}) => {
  const handleReload = () => {
    onSearchTermChange('');
    onReload();
  };

  return (
    <div className="flex items-center space-x-4 flex-1">
      <div className="flex-1">
        <Input
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="w-full"
        />
      </div>

      <div className="flex items-center space-x-2 flex-shrink-0">
        <Button
          onClick={onSearch}
          disabled={isLoading}
          className="bg-purple-600 hover:bg-purple-700 text-white px-6"
        >
          <Search className="h-4 w-4 mr-2" />
          {isLoading ? 'Loading...' : 'Search'}
        </Button>

        <Button
          onClick={handleReload}
          variant="outline"
          size="icon"
          disabled={isLoading}
          className="text-purple-600 border-purple-600 hover:bg-purple-50"
        >
          <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        </Button>
      </div>
    </div>
  );
};

export default VPESearchForm;